
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate-invisalign",
      function () {
        return require("private-next-pages/candidate-invisalign.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate-invisalign"])
      });
    }
  